<script lang="ts">
  import type { DistributorSimple, DefaultDistributors } from "@shared/types/Distributor";
  import Flash from "@shared/services/flashv2.js";
  import ProductTypesStore from "@shared/svelte/Stores/ProductTypesStore.js";
  import { get as getStoreValue } from "svelte/store";

  export let updateDefaultDistributor: (
    productId: number,
    distributorId: number,
    successCallback: any,
    errorCallback: any
  ) => any;

  export let defaultDistributors: DefaultDistributors = {};

  let disabled = false;

  const productTypes: [{ id: number; name: string }] =
    getStoreValue(ProductTypesStore)["types"] || [];

  const spiritsId = productTypes.find(type => type.name.toLowerCase() === "spirits")?.id;
  let spiritsDefaultedDistributorId = defaultDistributors[spiritsId]?.defaulted_distributor;
  let spiritsDefaultDistributorOptions: DistributorSimple[] =
    defaultDistributors[spiritsId]?.distributor_options || [];

  const getProductName = function (productTypeId: number) {
    return productTypes.find(type => type.id === productTypeId).name;
  };

  const getDistributorName = function (distributorId: number) {
    let distributor = spiritsDefaultDistributorOptions.find(
      distributor => distributor.id === distributorId
    );
    return distributor.name;
  };

  const successCallback = function (productTypeId: number, spiritsDefaultedDistributorId: number) {
    Flash.now({
      type: "success",
      message: `${getDistributorName(
        spiritsDefaultedDistributorId
      )} is now your default store for ${getProductName(productTypeId)}.`,
    });
  };

  const errorCallback = function (_res) {
    Flash.now({
      type: "error",
      message:
        "Sorry - we had a problem setting your default distributor. If you contact support we would be happy to help you.",
    });
  };

  const selectDefaultDistributor = function () {
    disabled = true;
    updateDefaultDistributor(
      spiritsId,
      spiritsDefaultedDistributorId,
      successCallback,
      errorCallback
    );
  };

</script>

{#if spiritsDefaultDistributorOptions.length}
  <div class="fizz-surface fizz-inset-square-24">
    <label class="fizz-label fizz-stack-8" for="default-spirits-distributor">
      Default Spirits store
    </label>
    <select
      class="fizz-select"
      name="default-spirits-distributor"
      id="default-spirits-distributor"
      bind:value={spiritsDefaultedDistributorId}
      on:change={selectDefaultDistributor}
      {disabled}
    >
      {#if !spiritsDefaultedDistributorId}
        <option value={null}>Select Option</option>
      {/if}
      {#each spiritsDefaultDistributorOptions as distributor}
        <option value={distributor.id}>{distributor.name}</option>
      {/each}
    </select>
  </div>
{/if}
